import client from './client';
import { CONVERSATIONS_API } from './routes';

/**
 * Conversations bound to a draft process — the transcript behind the editor's
 * assistant panel. They are deliberately absent from the main conversation
 * list, so they are only reachable through these two calls.
 */

// The control plane refuses both calls whenever the assistant is not available
// to this caller: 404 with the gate off, 403 for someone else's process. The
// 403 is a panel-level answer, not a dead session, so it must not log the user
// out the way an expired token does.
const ASSISTANT_REQUEST = { skipAuthRedirect: true } as const;

export interface ProcessConversationDto {
  readonly conversationId: string;
  readonly title: string | null;
  readonly createdAt: string;
  readonly lastActivityAt: string;
  readonly processId: string | null;
}

export async function listProcessConversations(
  processId: string,
): Promise<readonly ProcessConversationDto[]> {
  const { data } = await client.get<readonly ProcessConversationDto[]>(
    CONVERSATIONS_API,
    { params: { processId }, ...ASSISTANT_REQUEST },
  );
  return data;
}

export async function createProcessConversation(
  processId: string,
): Promise<ProcessConversationDto> {
  const { data } = await client.post<ProcessConversationDto>(
    CONVERSATIONS_API,
    { processId },
    ASSISTANT_REQUEST,
  );
  return data;
}
